import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Refresh({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Refresh</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0274 6.24767C13.9308 5.67072 12.688 5.41723 11.4453 5.52377C10.0052 5.64723 8.64725 6.24715 7.5862 7.22871C6.52516 8.21026 5.82152 9.51745 5.58651 10.9436C5.3515 12.3698 5.59852 13.8337 6.28854 15.1038C6.97855 16.3739 8.07219 17.3778 9.39659 17.9568C10.721 18.5358 12.2006 18.6569 13.6015 18.3009C15.0024 17.9449 16.2447 17.1322 17.132 15.9912C18.0194 14.8502 18.5011 13.446 18.5011 12.0006C18.5011 11.5863 18.8369 11.2506 19.2511 11.2506C19.6653 11.2506 20.0011 11.5863 20.0011 12.0006C20.0011 13.7795 19.4082 15.5077 18.3161 16.912C17.224 18.3163 15.6951 19.3166 13.9709 19.7547C12.2467 20.1928 10.4257 20.0438 8.79572 19.3312C7.16572 18.6186 5.81973 17.383 4.97049 15.8198C4.12126 14.2567 3.81723 12.4551 4.10647 10.6998C4.39571 8.94447 5.26171 7.33565 6.56759 6.1276C7.87347 4.91956 9.54473 4.1812 11.3172 4.02925C13.0484 3.88083 14.7797 4.30011 16.2499 5.2218L17.1952 4.42862C17.8131 3.91013 18.7547 4.3978 18.6843 5.20222L18.395 8.50926C18.3515 9.00723 17.9141 9.37425 17.4161 9.33069L14.109 9.04136C13.3046 8.97098 12.9809 7.96483 13.5988 7.44634L15.0274 6.24767Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
